import { Risk } from '@src/types';

export const getMainRiskCodesToString = (risks: Risk[] | undefined): string => {
  if (!!risks?.length) {
    return risks
      .filter((item) => item.binding && item.active)
      .map((item) => item.code)
      .join(', ');
  }

  return '';
};
